import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import upload from './upload/reducer';
import authUser from './auth/reducer';
import main from './main/reducer';


const reducers = combineReducers({
    menu,
    settings,
    main,
    upload,
    authUser
});

export default reducers;
